import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Intl } from '@erecruit/core';
import { connect } from 'react-redux';

import {
  registerDynamicWidgetConfig,
  WidgetContainer,
  registerWidgetResources,
  WidgetSpecType,
  widgetContainerActions,
  registerDefaultLayout,
} from '@erecruit/modules';
import { EditModeContext } from '../../App/components/EditModeContextProvider';
import {
  customRenderer,
  dynamicFieldsGetter,
  fieldsToFilterMapper,
} from './widgetExtensions';
import { counterWidgets } from './counterWidget';
import { tableWidgets } from './tableWidget';
import { RootState } from '../../redux/reducers';
import { getDefaultLayout } from './defaultLayout';

const WidgetContainerFramework = connect(
  (state: RootState) => ({
    widgetItems: state.app.widgetContainer.widgetItems,
    widgetLayouts: state.app.widgetContainer.widgetLayouts,
    widgetData: state.app.widgetContainer.widgetData,
  }),
  {
    addWidget: widgetContainerActions.addWidget,
    removeWidget: widgetContainerActions.removeWidget,
    refreshBatch: widgetContainerActions.refreshBatch,
    saveLayout: widgetContainerActions.saveLayout,
    loadLayout: widgetContainerActions.loadLayout,
    clearWidgets: widgetContainerActions.clearWidgets,
    restoreLayout: widgetContainerActions.restoreLayout,
  },
)(WidgetContainer);

const Dashboard = Intl.injectIntl(({ intl }: Intl.InjectedIntlProps) => {
  const history = useHistory();
  const { setEditMode } = useContext(EditModeContext);

  useEffect(() => {
    registerDefaultLayout(getDefaultLayout(intl));
  }, [intl]);

  return (
    <WidgetContainerFramework history={history} onEditMode={setEditMode} />
  );
});

registerDynamicWidgetConfig(
  customRenderer,
  dynamicFieldsGetter,
  fieldsToFilterMapper,
);

registerWidgetResources({
  [WidgetSpecType.counter]: counterWidgets,
  [WidgetSpecType.table]: tableWidgets,
});

export { Dashboard };
